import * as React from "react";
import * as ReactDOM from "react-dom";
import { Popup, PopupMessage } from "sb-resp-ui";
import { getPopupConfigs } from "../../helpers";
export class PopUp {
    constructor(config, msgStackContainer, legacyCallback) {
        this.config = getPopupConfigs(this, config, legacyCallback);
        this.msgContainer = document.createElement("div");
        this.msgStackContainer = msgStackContainer || document.body;
    }
    show() {
        this.msgStackContainer.appendChild(this.msgContainer);
        this.config.popupShowConfig.popupPortalEl = this.msgContainer;
        const msg = ReactDOM.render(React.createElement(Popup, {
            config: this.config.popupShowConfig
        }, React.createElement(PopupMessage, {
            config: this.config.popupMessageConfig
        })), this.msgContainer);
        return msg;
    }
    hide() {
        ReactDOM.unmountComponentAtNode(this.msgContainer);
        return this;
    }
}
//# sourceMappingURL=PopUp.js.map